/**
 * Tiny in-page signal that a booking changed outside the page showing it,
 * e.g. the scan return prompt ended the booking that BookingEdit has open.
 */

const EVENT = 'admin:booking-updated';

export function emitBookingUpdated(bookingId: string) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { bookingId } }));
}

/** Subscribe; returns the unsubscribe function. */
export function onBookingUpdated(callback: (bookingId: string) => void): () => void {
  const listener = (e: Event) => callback((e as CustomEvent).detail?.bookingId);
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
